import { useState, useEffect, useCallback } from "react";
import { User, UserService } from "@/shared/services/user.service";
import { MESSAGES } from "../users.constants";

/**
 * Custom hook for fetching users data
 * @returns Object containing users data, loading state, error state, and refetch function
 */
export const useUsers = () => {
  const [users, setUsers] = useState<User[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchUsers = useCallback(async () => {
    try {
      setLoading(true);
      const data = await UserService.getAll();
      setUsers(data);
      setError(null);
    } catch (err) {
      console.error("Failed to fetch users:", err);
      setError(MESSAGES.ERROR);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  return { users, loading, error, refetch: fetchUsers };
};
